export const InventoryStatusType = {
  InStock: 0,
  TemporarilyOutOfStock: 1,
  ReallyOutOfStock: 2, // Sold Out
};
